import { MapRegion, type Region } from "./Region.js"
import {
    Easing,
    Tween,
    Group as TweenGroup,
} from "./vendor/tweenjs/tween.esm.js"
import * as THREE from "three"

// Workaround for tween group type weirdness
const tweenGroup = new TweenGroup()

/**
 * Get the tween group associated with this Object3D
 * @param obj Object to get associated tween group of
 * @returns Tween group associated with the Object3D
 */
export function getTweenGroup(obj: THREE.Object3D): typeof tweenGroup {
    if ("tweens" in obj) {
        return obj.tweens as typeof tweenGroup
    } else {
        throw new Error("Object has no tween group")
    }
}

export function addTweenGroup(
    obj: THREE.Object3D & { tweens?: typeof tweenGroup }
): void {
    obj.tweens = new TweenGroup()
}

export function getRegion(obj: THREE.Object3D): Region {
    if ("region" in obj) {
        return obj.region as Region
    } else {
        throw new Error("Object has no region")
    }
}

export function unGrayAll(obj: THREE.Object3D): void {
    obj.traverse((obj) => {
        if (!(obj instanceof THREE.Mesh)) return
        // if (obj.tweens) {
        //     new Tween(obj, obj.tweens)
        //         .to({
        //             material: {
        //                 color: obj.userData.baseColor,
        //                 emissive: obj.userData.baseEmissive,
        //             },
        //             userData: {
        //                 inactiveColor: obj.userData.baseColor,
        //                 inactiveEmissive: obj.userData.baseEmissive,
        //             },
        //         }, 500)
        //         .easing(Easing.Quadratic.Out)
        //         .start();
        // } else {
        obj.material.color.copy(obj.userData.baseColor)
        obj.material.emissive.copy(obj.userData.baseEmissive)
        obj.userData.inactiveColor.copy(obj.userData.baseColor)
        obj.userData.inactiveEmissive.copy(obj.userData.baseEmissive)
        // }
    })
}

/**
 * Transfer the scale of one object to another.
 * Handles the case where source's scale is actively being animated.
 * @param source Object to take scale from.
 * @param destination Object to give scale to.
 */
export async function transferScale(
    source: THREE.Object3D,
    destination: THREE.Object3D
): Promise<void> {
    const tweens = getTweenGroup(source).getAll()
    if (tweens.length !== 0) {
        // Transfer scales
        const endValue = destination.scale
            .clone()
            .multiplyScalar(
                source.userData.clickedScale.x / source.userData.initialScale.x
            )
        const startValue = destination.scale
            .clone()
            .multiplyScalar(source.scale.x / source.userData.initialScale.x)

        // Transfer animation
        // const animation = source.userData.animation.duplicateTo(destination);
        // animation.endValue = endValue;
        // animation.startValue = startValue;
        // this.ANIMATIONS.add(animation);
        destination.scale.copy(startValue)
        const oldTween = tweens[0]
        await new Promise<void>((resolve) => {
            new Tween(destination, getTweenGroup(destination))
                .to({ scale: endValue })
                .copyTimingAndStart(oldTween)
                .onComplete(() => {
                    resolve()
                })
                .onStop(() => {
                    resolve()
                })
        })

        // newTween._duration = oldTween._duration;
        // newTween._startTime = oldTween._startTime;
    } else {
        destination.scale.multiplyScalar(
            source.userData.clickedScale.x / source.userData.initialScale.x
        )
    }
}

export function isMapGroup(group: THREE.Object3D): boolean {
    return group.userData.materials !== undefined
}

export function isMapMesh(obj: THREE.Object3D): boolean {
    if (!(obj instanceof THREE.Mesh)) return false
    return (
        !obj.name.includes("_") && obj.parent?.userData.materials !== undefined
    )
}

export function isNotMapMesh(mesh: THREE.Mesh): boolean {
    return !isMapMesh(mesh)
}

export function isTopBorder(mesh: THREE.Object3D): boolean {
    return mesh.name.endsWith("_TopBorder")
}

export function isTopLevel(
    obj: THREE.Object3D,
    topLevelObj: THREE.Object3D
): boolean {
    return obj.parent === topLevelObj
}

export function isFace(obj: THREE.Object3D, topLevel: THREE.Object3D): boolean {
    if (!(obj instanceof THREE.Mesh)) return false
    return isTopLevel(obj, topLevel) && !isTopBorder(obj)
}

// export function unGray(obj: THREE.Object3D): void {
//     obj.traverse((obj) => {
//         if (!("isMesh" in obj)) return

//         if (obj.name.endsWith("_BottomBorder")) return

//         const region = getRegion(obj)

//         if (region instanceof MapRegion) {
//             // obj.material = obj.parent.userData.materials.active[obj.parent.userData.mapLevel]
//             // obj.userData.inactive = false
//             region.activate()
//         } else {
//             new Tween(obj, getTweenGroup(obj))
//                 .to(
//                     {
//                         material: {
//                             color: obj.userData.baseColor,
//                             emissive: obj.userData.baseEmissive,
//                         },
//                         userData: {
//                             inactiveColor: obj.userData.baseColor,
//                             inactiveEmissive: obj.userData.baseEmissive,
//                         },
//                     },
//                     500
//                 )
//                 .easing(Easing.Quadratic.Out)
//                 .start()
//         }
//     })
// }
